import { takeLatest, call, put } from 'redux-saga/effects'
import { GET_PAYMENTS } from './actionTypes'
import { setLoader } from '../loader/actions'

import { setPayments } from './actions'
import paymentService from '../../supabaseServices/PaymentService'

export function* getPaymentsSagaFn() {
  try {
    yield put(setLoader(true))
    const res = yield call(paymentService.getPaginatedPayments, 1)
    yield put(setPayments(res))
  } catch (error) {
    console.log(error)
  } finally {
    yield put(setLoader(false))
  }
}

export default function* paymentSaga() {
  yield takeLatest(GET_PAYMENTS, getPaymentsSagaFn)
}
